import './Toast.css'
import { Icon } from './../icon/Icon'
import { useEffect, useState } from 'react'

const Toast = (props) => {
    const [isOpened, setIsOpened] = useState(false)

    const toastIcons = {
        success: {
            icon: (
                <Icon
                    variant="CheckCircle"
                    fill="#64D0BD"
                    width={40}
                    height={40}
                />
            ),
        },
        warning: {
            icon: (
                <Icon variant="Warning" fill="#FFCC00" width={40} height={40} />
            ),
        },
        info: {
            icon: <Icon variant="Info" fill="#76B4ED" width={40} height={40} />,
        },
        error: {
            icon: (
                <Icon variant="Error" fill="#F54D4D" width={40} height={40} />
            ),
        },
    }

    const getToastContainerClass = () => {
        switch (props.type) {
            case 'success':
                return 'toast-container success-background'
            case 'warning':
                return 'toast-container warning-background'
            case 'info':
                return 'toast-container info-background'
            default:
                return 'toast-container error-background'
        }
    }

    const getToastTitleClass = () => {
        switch (props.type) {
            case 'success':
                return 'success-title'
            case 'warning':
                return 'warning-title'
            case 'info':
                return 'info-title'
            default:
                return 'error-title'
        }
    }

    const { icon } = toastIcons[props.type]

    useEffect(() => {
        setIsOpened(true)
    }, [])

    return (
        <div
            className={getToastContainerClass()}
            style={{ transform: isOpened ? 'scale(1)' : 'scale(0)' }}
        >
            <span className="toast-icon">{icon}</span>
            <div className="toast-content">
                <div className={getToastTitleClass()}>{props.title}</div>
                {props.message ? <p>{props.message}</p> : null}
            </div>
            <Icon
                className="close-toast"
                variant="Close"
                fill="##333333"
                width={20}
                height={20}
                onClick={() => props.hideToast(props.id)}
            />
        </div>
    )
}

export default Toast
